import { Component, Inject } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseComponent } from 'src/app/core/components/base.component';
import { InfoTextService, InfoTextTranslationModel } from 'src/app/core/services/api-services';
import { BaseDialogComponent } from 'src/app/core/components/base-dialog.component';
import DownloadHelper from 'src/app/core/helpers/download.helper';
import { BreakpointObserver } from '@angular/cdk/layout';

@Component({
    selector: 'app-info-icon-dialog',
    templateUrl: './info-icon-dialog.component.html',
    styleUrls: ['./info-icon-dialog.component.scss'],
    standalone: false
})

export class InfoIconDialogComponent extends BaseDialogComponent {

  constructor(
    matDialogRef: MatDialogRef<InfoIconDialogComponent>,
    @Inject(MAT_DIALOG_DATA) protected readonly data: { infoText?: InfoTextTranslationModel },
    private readonly infoTextService: InfoTextService
  ) {
    super(matDialogRef);
  }

  public static open(component: BaseComponent, matDialog: MatDialog, breakpointObserver: BreakpointObserver, infoText: InfoTextTranslationModel, next?: () => void): void {
    const isMobile = breakpointObserver.isMatched('(max-width: 767px)');

    matDialog.open(InfoIconDialogComponent, {
      autoFocus: true,
      data: {
        infoText
      },
      maxWidth: isMobile ? '350px' : '600px'
    })
      .afterClosed()
      .unsubscribeOnDestroy(component)
      .subscribe(() => {
        if(next) {
          next();
        }
      });
  }

  protected downloadInfoFile(): void {
    if(this.data.infoText?.infoFileId) {
      this.infoTextService.downloadFile(this.data.infoText?.infoFileId)
        .subscribe(file => {
          if (file) {
            DownloadHelper.downloadFile(file); // TODO: make the file downloadable
          }
        });
    }
  }
}
